import React from "react";
import { Link } from "react-router-dom";
import { MailIcon, PhoneIcon } from "../assets/icons";
import "./Footer.css";

const Footer = () => (
  <footer className="footer-modern">
    <div className="container footer-inner">
      <div className="footer-brand-column">
        <Link to="/" className="footer-logo-link">
          <span className="footer-brand-title">Kafue Technologies</span>
        </Link>
        <p className="footer-brand-tagline">More than just technology.</p>
      </div>

      <div className="footer-nav-column">
        <h4>Navigation</h4>
        <Link to="/about">About Us</Link>
        <Link to="/what-we-do">What We Do</Link>
        <Link to="/contact">Contact Us</Link>
      </div>

      {/* <div className="footer-legal-column">
        <h4>Legal</h4>
        <a href="#">Privacy Protocol</a>
        <a href="#">Terms of Architecture</a>
      </div> */}

      <div className="footer-comms-column">
        <h4>Channels</h4>
        <a
          href="mailto:info@kafuetechnologies.com"
          aria-label="Email Setup"
          className="comms-link"
        >
          <MailIcon size={18} stroke="var(--text-muted)" />
          <span>info@kafuetechnologies.com</span>
        </a>
        <a
          href="tel:+27825468309"
          aria-label="Phone Comms"
          className="comms-link"
        >
          <PhoneIcon size={18} stroke="var(--text-muted)" />
          <span>+27 82 546 8309</span>
        </a>
      </div>
    </div>

    <div className="footer-bottom-bar container">
      <p>
        &copy; {new Date().getFullYear()} Kafue Technologies. Built in Pretoria,
        South Africa. All rights reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
